import React from "react";
import "./index.css";

export default function AddButton({
  label,
  dataTarget,
  className,
  hex,
  white,
}) {
  return (
    <button
      className={`btn btn-secondary add-btn ${className}`}
      style={{ "--hex": hex, "--text-color": white ? "white" : "black" }}
      data-toggle="modal"
      data-target={dataTarget}
    >
      {label}
    </button>
  );
}



// WEBPACK FOOTER //
// ./src/components/AddButton/index.js